import { Reorder } from "framer-motion";

import { Button } from "../ui/button";

import { getGateColour, cn, shortenName } from "../../../utils/helper-funcs";
import { getFlag } from "../../../images/flags/getFlag";
import { useEventData } from "../DataProvider";
import { Racer } from "../RaceOrderProvider";

interface RaceOrderSlipProps {
  racer: Racer;
  idx: number;
  onClick: (num: number) => void;
}

export function RaceOrderSlip({ onClick, racer, idx }: RaceOrderSlipProps) {
  const { competitorsData } = useEventData();
  const cardinal =
    competitorsData.find((c) => c.name === racer.racerName)?.cardinal ?? 0;
  return (
    <Reorder.Item
      dragListener={false}
      value={racer}
      key={racer.racerName}
      style={{
        borderColor: getGateColour(cardinal),
      }}
      className={cn("border-l-8", getSlipDimensions(idx))}
    >
      <Button
        className="flex items-center justify-start w-full h-full gap-2 py-1 bg-secondary md:py-4"
        onClick={() => onClick(racer.racerNumber - 1)}
      >
        <div
          className={cn(
            "flex items-start justify-center",
            getCardinalWidth(idx),
          )}
        >
          <p className="italic font-extrabold md:text-2xl">{cardinal}</p>
        </div>
        <div className="flex items-center justify-between flex-1 gap-2 lg:justify-start">
          <div className={getImageSize(idx)}>
            <img
              src={getFlag(racer.racerName)}
              alt=""
              className="object-cover w-full h-full"
            />
          </div>
          <span className="hidden text-lg italic lg:inline ">
            {shortenName(racer.racerName)}
          </span>
        </div>
      </Button>
    </Reorder.Item>
  );
}

function getSlipDimensions(num: number) {
  switch (num) {
    case 0:
      return "md:w-32 lg:w-[280px] h-10 md:h-14 lg:h-[72px]";
    case 1:
      return "md:w-28 lg:w-[256px] h-8 md:h-12 lg:h-[64px]";
    case 2:
      return "md:w-24 lg:w-[232px] h-7 md:h-11 lg:h-[56px]";
    default:
      return "md:w-[88px] lg:w-[208px] h-6 md:h-8 lg:h-[48px]";
  }
}

function getImageSize(num: number) {
  switch (num) {
    case 0:
      return "w-7 h-7 md:w-8 md:h-8";
    case 1:
      return "w-6 h-6 md:w-7 md:h-7";
    case 2:
      return "w-5 h-5 md:w-6 md:w-6";
    default:
      return "w-4 h-4 md:w-5 md:w-5";
  }
}

function getCardinalWidth(num: number) {
  switch (num) {
    case 0:
      return "w-10 md:w-12";
    case 1:
      return "w-8 md:w-11";
    case 2:
      return "w-7 md:w-8";
    default:
      return "w-5 md:w-6 lg:w-8";
  }
}
